<template>
  <div class="mb-1">
    <label class="block text-sm font-bold text-700 mb-0 text-uppercase tracking-wider">Método de Pago</label>
    <div class="grid m-0 w-full" style="margin-left: -0.25rem; margin-right: -0.25rem;">
      <div 
        v-for="metodo in metodos"
        :key="metodo.value"
        class="col p-1"
      >
        <div 
          class="zapi-pay-card h-full w-full m-0 border-round-xl border-2" 
          :class="[
            { 'zapi-pay-active': modelValue === metodo.value },
            { 'zapi-pay-disabled': metodo.disabled }
          ]" 
          @click="!metodo.disabled && cambiarMetodo(metodo.value)"
        >
          <i :class="metodo.icon"></i>
          <span class="text-center">{{ metodo.label }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ZapiPaymentSelector',
  props: {
    modelValue: { type: [String, Number], required: true },
    metodos: {
      type: Array,
      default: () => [
        { label: 'Efectivo', value: 'efectivo', icon: 'pi pi-money-bill' }
      ]
    }
  },
  emits: ['update:modelValue'],
  methods: {
    cambiarMetodo(metodo) {
      this.$emit('update:modelValue', metodo);
    }
  }
}
</script>

<style scoped>
.zapi-pay-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border-color: #f0ebe2; /* Borde idéntico al ZapiProductCard */
  padding: 0.4rem 0;
  background-color: white;
  color: #4b5563;
  font-weight: 700;
  font-size: 0.95rem;
  cursor: pointer;
  transition: border-color 0.15s ease-in-out, color 0.15s ease-in-out;
}
.zapi-pay-card i {
  font-size: 1.2rem;
}
.zapi-pay-card:not(.zapi-pay-disabled):hover {
  border-color: #e32f3a;
  color: #e32f3a;
}
.zapi-pay-active {
  border: 2px solid #e32f3a !important;
  color: #e32f3a !important;
}
.zapi-pay-disabled {
  opacity: 0.5;
  cursor: not-allowed !important;
  background-color: #f3f4f6;
}
</style>